const CONSENT_KEY = "incooking_consent_analytics";
const GRANTED = "granted";
const DENIED = "denied";

function hasWindow() {
  return typeof window !== "undefined" && typeof window.localStorage !== "undefined";
}

export function getConsent() {
  if (!hasWindow()) return null;
  const value = window.localStorage.getItem(CONSENT_KEY);
  if (value === GRANTED || value === DENIED) return value;
  return null;
}

export function grantAnalytics() {
  if (!hasWindow()) return;
  window.localStorage.setItem(CONSENT_KEY, GRANTED);
}

export function denyAnalytics() {
  if (!hasWindow()) return;
  window.localStorage.setItem(CONSENT_KEY, DENIED);
}

export const ANALYTICS_CONSENT_KEY = CONSENT_KEY;
